































































































































































































































import {Component, Inject, Prop, Vue, Watch} from "vue-property-decorator";
import {ISegmentationTargetService} from "@/modules/Segmentation/services/ISegmentationTargetService";
import {container} from "@/services/registerServiceProvider";
import Loader from "@/components/Loader.vue";
import SegmentationRules from "@/components/SegmentationRules.vue";
import {Helpers, StateMachine} from "frontend-core";
import {IStoreService} from "@/services/IStoreService";
import {SegmentRule} from "@/modules/Segmentation/models/SegmentRule";
import {AntiSegmentRule} from "@/modules/Segmentation/models/AntiSegmentRule";
import {SegmentationTargetDTO} from "@/modules/Segmentation/models/SegmentationTargetDTO";
import {IUserRoleService} from "@/services/IUserRoleService";
import SegmentationRulesTypeTabs from "@/components/SegmentationRulesTypeTabs.vue";
import SegmentationRuleForm from "@/components/SegmentationRuleForm.vue";
import SegmentationNestingApprove from "@/components/SegmentationNestingApprove.vue";
import {Agent} from "@/models/Agent";
import ToSegmentationLogsLink from "@/components/ToSegmentationLogsLink.vue";
import SegmentationNestingChange from "@/components/SegmentationNestingChange.vue";
import DisableRule from "@/components/DisableRule.vue";
import DeleteRule from "@/components/DeleteRule.vue";
import ErrorNotification from "@/components/ErrorNotification.vue";
import {SegmentationTarget} from "@/modules/Segmentation/models/SegmentationTarget";
import {NavigationGuard, NavigationGuardNext, Route} from "vue-router";
import {ISegmentationRightsService} from "@/modules/Segmentation/services/ISegmentationRightsService";
import BlockAgentMessage from "@/components/BlockAgentMessage.vue";

const navigationGuard: NavigationGuard = async (to, from, next) => {
  const isAllow: boolean = await container
          .resolve<ISegmentationRightsService>("ISegmentationRightsService")
          .isAllowEdit(to.params.agentId)
      && !container.resolve<IUserRoleService>("IUserRoleService").isHasChangeParentRole;

  if (isAllow) {
    next();
  } else {
    next({
      name: "segmentation-report",
      params: to.params
    });
  }
}

@Component({
  components: {
    DeleteRule,
    DisableRule,
    SegmentationNestingChange,
    ToSegmentationLogsLink,
    SegmentationNestingApprove,
    BlockAgentMessage,
    SegmentationRuleForm, SegmentationRulesTypeTabs, SegmentationRules, Loader,
    ErrorNotification
  },
  beforeRouteEnter: navigationGuard,
  beforeRouteUpdate: navigationGuard,
})
export default class SegmentationEditor extends Vue {
  @Prop() public readonly agent!: Agent;
  @Prop() public readonly segmentation!: SegmentationTarget;
  @Prop() public readonly preSelectedRuleIndex?: string;
  @Prop() public readonly preSelectedRuleKeyIndex?: string;
  public previousHashCode: string = "";
  public newHashCode: string = "";
  public rulesKeyIndex: number = 0;
  public errorText: string = "";
  public readonly stateMachine: StateMachine = new StateMachine("idle", {
    idle: ["loading", "error"],
    loading: ["success", "error"],
    success: ["idle"],
    error: ["idle"],
  });
  public selectedRuleIndex: number | null = null;
  public showNestingApprove: boolean = false;
  public isAllowEditMasterRules: boolean = false;
  public showSaveBefore: boolean = false;
  public answer: Function = () => {
    return false
  };
  private readonly userRoleService: IUserRoleService = container.resolve("IUserRoleService");

  @Inject()
  private readonly storeService!: IStoreService;
  private readonly segmentationTargetService: ISegmentationTargetService = container
      .resolve("ISegmentationTargetService");

  get rules(): Array<SegmentRule | AntiSegmentRule> {
    return this.segmentation[this.rulesKeyIndex ? "segments" : "antiSegments"]
        .filter(rule => {
          return (rule.isMasterRule.boolean && this.userRoleService.isAdmin) || !rule.isMasterRule.boolean
        });
  }

  async created() {
    this.isAllowEditMasterRules = this.userRoleService.isAdmin
        && this.userRoleService.isUserAdmin(this.agent.user);

    this.previousHashCode = this.segmentationTargetService.getHashCode(this.segmentation);
    this.newHashCode = this.previousHashCode;

    if (this.preSelectedRuleKeyIndex) {
      this.rulesKeyIndex = parseInt(this.preSelectedRuleKeyIndex);
    }

    if (this.preSelectedRuleIndex) {
      this.selectedRuleIndex = parseInt(this.preSelectedRuleIndex);
    }
  }

  mounted() {

    if (this.preSelectedRuleKeyIndex) {
      this.rulesKeyIndex = parseInt(this.preSelectedRuleKeyIndex);
    }

    if (this.preSelectedRuleIndex) {
      this.selectedRuleIndex = parseInt(this.preSelectedRuleIndex);
    }
  }

  async beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    await this.showAndAskSaveChanges(to, from, next);
  }

  async beforeRouteUpdate(to: Route, from: Route, next: NavigationGuardNext) {
    await this.showAndAskSaveChanges(to, from, next);
  }

  async inheritSegmentationToAll() {
    if (this.stateMachine.state !== "loading") {
      this.stateMachine.transition("loading");
        await this.segmentationTargetService.setInheritedSegmentation(this.agent.id)
          .then(() => {
            this.stateMachine.transition("success");
          })
          .catch((e) => {
            this.stateMachine.transition("error");
            console.error(e);
          });
    }
  }

  async showAndAskSaveChanges(to: Route, from: Route, next: NavigationGuardNext) {
    if (to.name !== "login" && this.previousHashCode !== this.newHashCode) {
      this.showSaveBefore = true;

      await this.askSaveChanges()
          .finally(() => {
            if (this.stateMachine.state !== "error" && this.stateMachine.state !== "loading") {
              next();
            }
          });
    } else {
      next();
    }
  }

  askSaveChanges() {
    this.showSaveBefore = true;

    return new Promise((resolve) => {
      this.answer = resolve;
    })
  }

  async saveChangesAndGo(): Promise<void> {
    this.showSaveBefore = false;

    await this.save()
        .then(() => {
          this.answer(true);
        });
  }

  undoChangesAndGo(): void {
    this.showSaveBefore = false;
    this.$emit('refresh', this.agent);
    this.answer(false);
  }

  toReport() {
    this.$router.push({
      name: "segmentation-report",
      params: {agentId: this.agent.id},
      query: {
        selectedRuleIndex: String(this.selectedRuleIndex),
      }
    });
  }

  toIdle(e: boolean): void {
    if (!e) {
      this.stateMachine.transition("idle");
    }
  }

  public async save(): Promise<void> {
    if (this.stateMachine.state !== "loading") {
      this.stateMachine.transition("loading");

      if (new SegmentationTargetDTO(this.segmentation).validate()) {
        await this.segmentationTargetService.update(this.segmentation)
            .then(() => {
              this.$emit('refresh', this.agent);
              this.previousHashCode = this.newHashCode;
              this.stateMachine.transition("success");
            })
            .catch((e) => {
              this.stateMachine.transition("error");
              this.errorText = e.response.data.detail || "";
            });
      } else {
        this.stateMachine.transition("error");
      }
    }
  }

  deleteRule(index: number | null): void {
    if (index !== null) {
      this.segmentation[this.rulesKeyIndex ? "segments" : "antiSegments"]
          .splice(index, 1);
    }
  }

  async toggleLock(): Promise<void> {
    this.stateMachine.transition("loading");

    if (!this.segmentation.parentId) {
      await this.segmentationTargetService.lock(this.segmentation, this.agent)
          .then((data) => {
            this.$emit("refresh", data);

            this.stateMachine.transition("success");
          })
          .catch((e) => {
            this.stateMachine.transition("error");
            this.errorText = e.response?.data.detail || "";
          });
    } else {
      await this.segmentationTargetService.unLock(this.segmentation)
          .then((data) => {
            this.$emit("refresh", data);

            this.stateMachine.transition("success");
          })
          .catch((e) => {
            this.stateMachine.transition("error");
            this.errorText = e.response?.data.detail || "";
          });
    }

    this.newHashCode = this.segmentationTargetService.getHashCode(this.segmentation);
  }

  @Watch('segmentation', {deep: true})
  private watchValue(): void {
    Helpers.pause(1000)
        .then(() => {
          this.newHashCode = this.segmentationTargetService.getHashCode(this.segmentation);
        });
  }

}
